import React from 'react'
import { BrowserRouter, Routes, Route } from "react-router-dom"
import { HelmetProvider } from 'react-helmet-async';
import Header from './Components/Header'
import Home from './Components/Home'
import AboutUs from './Components/AboutUs'
import WealthManagement from './Components/WealthManagement'
import PortfolioManagementServices from './Components/PortfolioManagementServices'
import TaxPlanning from './Components/TaxPlanning'
import OffshoreProducts from './Components/OffshoreProducts'
import EstatePlanning from './Components/EstatePlanning'
import AlternativeInvestments from './Components/AlternativeInvestments'
import PrivateEquity from './Components/PrivateEquity'
import PrivateCredit from './Components/PrivateCredit'
import FinancialPlanning from './Components/FinancialPlanning'
import GoalBasedInvestments from './Components/GoalBasedInvestments'
import RetirementPlanning from './Components/RetirementPlanning'
import PostRetirementSolutions from './Components/PostRetirementSolutions'
import FirePlanning from './Components/FirePlanning'
import CorporateFinancialWellness from './Components/CorporateFinancialWellness'
import AssetManagement from './Components/AssetManagement'
import StocksInvestment from './Components/StocksInvestment'
import MutualFundsInvestment from './Components/MutualFundsInvestment'
import HomeLoan from './Components/HomeLoan'
import CarLoan from './Components/CarLoan'
import EducationLoan from './Components/EducationLoan'
import Articles from './Components/Articles'
import VideoClips from './Components/VideoClips'
import ImageGallery from './Components/ImageGallery'
import ContactUs from './Components/ContactUs'
import Footer from './Components/Footer'
import PrivacyPolicy from './Components/PrivacyPolicy';
import TermsOfService from './Components/TermsOfService';
import RefundAndCancellationPolicy from './Components/RefundAndCancellationPolicy';
import Support from './Components/Support';

const App = () => {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <div>
          <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/wealth-management" element={<WealthManagement />} />
            <Route path="/portfolio-management-services" element={<PortfolioManagementServices />} />
            <Route path="/tax-planning" element={<TaxPlanning />} />
            <Route path="/offshore-products" element={<OffshoreProducts />} />
            <Route path="/estate-planning" element={<EstatePlanning />} />
            <Route path="/alternate-investments" element={<AlternativeInvestments />} />
            <Route path="/private-equity" element={<PrivateEquity />} />
            <Route path="/private-credit" element={<PrivateCredit />} />
            <Route path="/financial-planning" element={<FinancialPlanning />} />
            <Route path="/goal-based-investments" element={<GoalBasedInvestments />} />
            <Route path="/retirement-planning" element={<RetirementPlanning />} />
            <Route path="/post-retirement-solutions" element={<PostRetirementSolutions />} />
            <Route path="/fire-planning" element={<FirePlanning />} />
            <Route path="/corporate-financial-wellness" element={<CorporateFinancialWellness />} />
            <Route path="/asset-management" element={<AssetManagement />} />
            <Route path="/stock-investment" element={<StocksInvestment />} />
            <Route path="/mutual-funds-investment" element={<MutualFundsInvestment />} />
            <Route path='/home-loan' element={<HomeLoan />} />
            <Route path="/car-loan" element={<CarLoan />} />
            <Route path="/education-loan" element={<EducationLoan />} />
            <Route path="/articles" element={<Articles />} />
            <Route path="/video-clips/*" element={<VideoClips />} />
            <Route path="/image-gallery" element={<ImageGallery />} />
            <Route path="/contact-us" element={<ContactUs />} />

            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
            <Route path="/refund-and-cancellation-policy" element={<RefundAndCancellationPolicy />} />
            <Route path="/support" element={<Support />} />
          </Routes>
          <Footer />
        </div>
      </BrowserRouter>
    </HelmetProvider>
  )
}

export default App